import { Icon, Popover, Transition } from '@lounge-fe/ui-kit'
import classNames from 'classnames'
import { ModelSelectorProps } from './types'
import { MediaButton, MediaButtonContainer } from './MediaButton'

export const ModelSelector = ({
  models,
  selectedModel,
  onChange,
}: ModelSelectorProps) => {
  const canChangeModel = models.size > 1
  return (
    <MediaButtonContainer data-testid="model-selector">
      <Popover scrollLock={false}>
        {({ onClose, isOpen }) => (
          <>
            <Popover.Trigger
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
            >
              <MediaButton disabled={!canChangeModel}>
                <span>{selectedModel}</span>
                {canChangeModel && (
                  <Icon.ChevronDown
                    className={classNames(
                      'w-2 transition-transform',
                      isOpen && 'rotate-180',
                    )}
                  />
                )}
              </MediaButton>
            </Popover.Trigger>
            <Transition.Fade>
              <Popover.Content
                onClickAway={(e) => {
                  onClose()
                  e.preventDefault()
                  e.stopPropagation()
                }}
                className="bg-surface-secondary-default overflow-hidden absolute bottom-full mb-2 shadow-1 p-2"
              >
                <div role="radiogroup">
                  {[...models].map((model) => (
                    <button
                      role="radio"
                      key={model}
                      aria-checked={model === selectedModel}
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        onChange(model)
                        onClose()
                      }}
                      className="w-full text-sm text-left p-2 hover:bg-surface-secondary-hovered whitespace-nowrap flex jutify-between items-center"
                    >
                      <span className="mr-4">{model}</span>
                      {model === selectedModel && (
                        <div className="rounded-circle bg-inverse w-3 h-3 p-1">
                          <Icon.Check className="text-white max-w-full max-h-full" />
                        </div>
                      )}
                    </button>
                  ))}
                </div>
              </Popover.Content>
            </Transition.Fade>
          </>
        )}
      </Popover>
    </MediaButtonContainer>
  )
}
